/**
 * Handles search from header
 * @module search
 */

import $ from 'jquery';
import breaky from 'breaky';

function initEventHandlers() {
  const hamburgerLinks = $('#js-menu-link');
  const logo = $('.site-header__logo');
  const searchAndBagIcons = $('.nav-secondary');
  const searchBtn = $('#search-button');
  const mobileSearch = $('#mobileSearch');
  const mobileSearchClose = $('#mobileSearchClose');
  const mobileSearchInput = $('#mobileSearchInput');
  const desktopSearch = $('#desktopSearchForm');
  const siteHeader = $('.site-header');
  const searchWrapper = $('.site-search-tray__wrapper');
  const navPrimary = $('.nav-primary');

  const clientYSet = null; // remember Y position on touch start
  let searchAppended = false;
  let searchActive = false;

  function isOverlayTotallyScrolled() {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
    return searchWrapper.scrollHeight - searchWrapper.scrollTop <= searchWrapper.clientHeight;
  }

  function disableRubberBand(event) {
    const clientY = event.targetTouches[0].clientY - clientYSet;

    if (searchWrapper.scrollTop === 0 && clientY > 0) {
      // element is at the top of its scroll
      event.preventDefault();
    }

    if (isOverlayTotallyScrolled() && clientY < 0) {
      // element is at the top of its scroll
      event.preventDefault();
    }
  }

  function hideSearch() {
    mobileSearch.hide();
    searchWrapper.fadeOut('800', () => {
      searchActive = false;
    });
    hamburgerLinks.show();
    logo.show();
    searchAndBagIcons.show();
    siteHeader.css({
      padding: '',
    }); // Add OG padding back in
  }

  function trayToggle() {
    if (searchActive) {
      hideSearch();
    } else {
      searchWrapper.show();
      mobileSearch.show();
      siteHeader.css({
        padding: 0,
      }); // Remove OG padding
      mobileSearchInput.focus();
      searchActive = true;

      searchWrapper.on('touchmove', (event) => {
        if (event.targetTouches.length === 1) {
          // detect single touch
          disableRubberBand(event);
        }
      }, false);
    }
  }

  function triggerSearch() {
    hamburgerLinks.hide();
    logo.hide();
    searchAndBagIcons.hide();
    trayToggle();
  }

  // Group 1
  breaky.below('mobile', () => {
    desktopSearch.hide();

    if (!searchAppended) {
      if (searchBtn.hasClass('search-button-desktop')) {
        searchBtn.removeClass('search-button-desktop');
      }
      searchBtn.addClass('search-button-mobile');

      $('.search-button-mobile').on('click', triggerSearch);
      mobileSearchClose.on('click', hideSearch);

      searchAppended = true;
    }

    $('.js-focus-to-search').on('click', () => {
      searchBtn.trigger('click');
    });
  });
  breaky.above('tablet', () => {
    if (searchAppended) {
      searchBtn.off('click', triggerSearch);
      searchWrapper.off('click', hideSearch);
      hideSearch();
      searchAppended = false;
    }
    if (searchBtn.hasClass('search-button-mobile')) {
      searchBtn.removeClass('search-button-mobile');
    }
    searchBtn.addClass('search-button-desktop');

    desktopSearch.show();

    $('.js-focus-to-search').on('click', () => {
      $('#desktopSearchForm input').focus();
    });
  });

  // Group 2
  breaky.below('tablet', () => {
    navPrimary.hide();
    hamburgerLinks.show();
  });
  breaky.above('small-desktop', () => {
    hamburgerLinks.hide();
    navPrimary.show();
  });
}

$(document).ready(() => {
  initEventHandlers();
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/search.js